import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';

function insertPreRequestPath(url: string, basePath = 'share'): string {
    const urlObj = new URL(url)
    const requestPath = urlObj.pathname
    if (requestPath.startsWith('/eureka/')) {
        urlObj.pathname = requestPath.replace('/eureka/', `/eureka/${basePath}/`)
    } else if (requestPath.startsWith('/api/research/')) {
        urlObj.pathname = requestPath.replace('/api/research/', `/api/research/${basePath}/`)
    } else {
        urlObj.pathname = `/eureka/${basePath}${requestPath}`
    }
    return urlObj.toString()
}

/**
 * 分享后，需要将请求路径中前面加上/eureka/share，被分享人可以访问到分享的资源
 */
const needPreShareAPIList = [
    /**
     * 以下接口需要将请求路径中/eureka替换为/eureka/share
     */

    /**
     * seek 分享
     */
    'seek/init',
    'seek/outline',
    'seek/get-pum-chart',

    /**
     * Mind 分享
     */
    'tech-mind/[^/]+',
    'material-mind/[^/]+',
    'material-mind/v2/[^/]+',
    'material-mind/sse/get-implementation',

    /**
     *  monitor 分享
     */
    'tech-monitor/[^/]+/pre_check_status',
    'tech-monitor/[^/]+/range',
    'tech-monitor/[^/]+/pre_compute',
    'tech-monitor/[^/]+',
    'tech-monitor/[^/]+/count',
    'tech-monitor/[^/]+/key-overview',
    'tech-monitor/chart/[^/]+',
    'tech-monitor/top_company_chart/[^/]+',
    'tech-monitor/[^/]+/tech_groups',
    'tech-monitor/[^/]+/company_groups',
    'tech-monitor/[^/]+/other_groups',
    'tech-monitor/[^/]+/overview',
    'tech-monitor-config/[^/]+',

    /**
     * Mind 分享
     */
    'triz-mind/message',
    'triz-mind/version',
    'triz-mind/idea/novelty-copy',
    'triz-mind/idea/validation-copy',
    'triz-mind/idea/refine-stream',

    /**
     * 以下接口需要将请求路径前面加上/eureka/share
     */
    'ai-agent-api/job/messages',
    'discovery-api/2.0/organization/[^/]+/info',

    /**
     * 以下接口需要将请求路径前面加上/api/research/share
     */
    'conversations/[^/]+/stream'
];

/**
 * 游客版，需要将请求路径中前面加上/eureka/guest，游客可以访问接口
 */
const needPreGuestAPIList = [
    /**
     * 以下接口需要将请求路径中/eureka替换为/eureka/guest
     */

    /**
     * Home游客版
     */
    'homepage/init',
    'agent/example',
    'recommend-cards',
    'product-cards',

    /**
     * Mind 游客版
     */
    'tech-mind/[^/]+/push',
    'sse/tech-mind/solution',
    'agent/tech-mind/push-direction',
    'material-mind/[^/]+/push',
    'sse/material-mind/solution',

    /**
     * Formulation 游客版
     */
    'material/formulation/get-extracted-data',
    'material/formulation/get-generated-data',
    'material/formulation/get-feasibility-analysis',
    'material/formulation/submit-single-summarisation',
    'material/formulation/get-single-summarisation',

    /**
     * 以下接口需要将请求路径前面加上/eureka/guest
     */
    'ai-agent-api/job/chat',
    'ai-agent-api/job/execute-plan',

    'plg-home-page/plg-recommend-cases',

    /**
     * 以下接口需要将请求路径前面加上/api/research/guest
     */
    'sessions',
    'sessions/[^/]+/chart-data',
    'sessions/[^/]+/documents'
];

function escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const whiteListForJs = _.map(needPreShareAPIList, (item) => {
    const replaceKongRule = escapeRegExp(item.replace(/\[\^\/\]\+/g, '@'));
    const buildJsExp = replaceKongRule.replace(/@/g, '[a-zA-Z0-9_-]+') + '$';
    return new RegExp(buildJsExp);
});

const guestWhiteListForJs = _.map(needPreGuestAPIList, (item) => {
    const replaceKongRule = escapeRegExp(item.replace(/\[\^\/\]\+/g, '@'));
    const buildJsExp = replaceKongRule.replace(/@/g, '[a-zA-Z0-9_-]+') + '$';
    return new RegExp(buildJsExp);
});

export const airShareInterceptor = async(config) => {
    const fullUrl = config.url.startsWith('http') ? config.url : config.baseURL + config.url
    if (_.some(whiteListForJs, (item) => item.test(fullUrl.split('?')[0]))) {
        config.url = insertPreRequestPath(fullUrl);
    }

    if (_.some(guestWhiteListForJs, (item) => item.test(fullUrl.split('?')[0]))) {
        config.url = insertPreRequestPath(fullUrl, 'guest');
    }
    return config;
};

export function injectAirShareInterceptor() {
    if (!psAxios.psInterceptors.airShareInterceptor) {
        psAxios.psInterceptors.airShareInterceptor = psAxios.interceptors.request.use(airShareInterceptor, () => { });
    }
}

export function ejectAirShareInterceptor() {
    psAxios.interceptors.request.eject(
        psAxios.psInterceptors.airShareInterceptor
    );
}
